"use strict";
exports.__esModule = true;
exports.getNavigatorLanguage = exports.labels = void 0;
var supportedLanguages = {
    en: "en_US",
    fr: "fr_FR",
    ar: "ar_AR",
    es: "es_ES",
    de: "de_DE",
    pt: "pt_PT",
    zh: "zh_CN",
    he: "he_IL"
};
exports.labels = {
    en_US: {
        continue_with: "Continue with Facebook",
        login_with: "Login with Facebook"
    },
    fr_FR: {
        continue_with: "Continuer avec Facebook",
        login_with: "Connexion avec Facebook"
    },
    ar_AR: {
        continue_with: "متابعة مع فيسبوك",
        login_with: "تسجيل الدخول باستخدام فيسبوك"
    },
    es_ES: {
        continue_with: "Continuar con Facebook",
        login_with: "Iniciar sesión con Facebook"
    },
    de_DE: {
        continue_with: "Mit Facebook fortfahren",
        login_with: "Mit Facebook anmelden"
    },
    pt_PT: {
        continue_with: "Continuar com o Facebook",
        login_with: "Entrar com o Facebook"
    },
    zh_CN: {
        continue_with: "继续使用 Facebook",
        login_with: "使用 Facebook 登录"
    },
    he_IL: {
        continue_with: "המשך עם פייסבוק",
        login_with: "התחבר עם פייסבוק"
    }
};
/**
 * Get the ISO language code based on the navigator language or fallback to the nearest alternative.
 * @returns {ISOLangCountry} The ISO language code.
 */
function getNavigatorLanguage() {
    var language = "en";
    if (typeof navigator !== "undefined" && navigator.language) {
        var navigatorLanguage = navigator.language.slice(0, 2);
        if (supportedLanguages[navigatorLanguage]) {
            language = navigator.language;
        }
    }
    if (language.includes("-")) {
        language = language.replace("-", "_");
    }
    if (!language.includes("_")) {
        if (supportedLanguages[language]) {
            language = supportedLanguages[language];
        }
        else {
            var languageCode_1 = language.split("_")[0];
            var fallbackLanguage = Object.values(supportedLanguages).find(function (value) {
                return value.startsWith(languageCode_1);
            });
            language = fallbackLanguage || language;
        }
    }
    return language;
}
exports.getNavigatorLanguage = getNavigatorLanguage;
//# sourceMappingURL=locales.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tusken-s/facebook-tools/dist/cjs/locales.js
// module id = 150
// module chunks = 168707334958949